import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";

export async function deleteAccount(userId: number): Promise<IApiResponse<any>> {
    const endpoints = await getEndpoints();
    const endpoint = endpoints.deleteAccount(userId);
    return await apiRequest<any>(endpoint, "DELETE");
} 